import { createSlice } from '@reduxjs/toolkit'
import { generateUUID } from 'utils/helpers'

const initialState = {
  gb_application: [],
  gbApplicationFileLoader: false,
  gbApplicationFileLoaderId: ''
}

export const gbApplicationFilesSlice = createSlice({
  name: 'gb_application_files',
  initialState,
  reducers: {
    initializeGbApplicationFiles: () => {
      return { ...initialState }
    },
    setGbApplicationFile: (state, action) => {
      const { gb_application } = action.payload
      state.gb_application.push({ ...gb_application })
    },
    setGbApplicationFiles: (state, action) => {
      const { gb_applications } = action.payload
      state.gb_application = gb_applications
      return state
    },
    updateGbApplicationFile: (state, action) => {
      const { gb_applications } = action.payload
      state.gb_application = gb_applications
      return state
    },
    setGbApplicationImage: (state, action) => {
      const { id } = action.payload

      const itemIndex = state.gb_application.findIndex((_, idx) => idx === id?.idx)

      if (itemIndex !== -1 && id) {
        if (!state.gb_application[itemIndex].files) {
          state.gb_application[itemIndex].files = []
        }
        if (id?.file?.file_obj) {
          const fileObj = id.file.file_obj
          const structuredFile = {
            id: fileObj.id || generateUUID(),
            file_obj: {
              id: fileObj.id,
              document_revision_id: fileObj.document_revision_id,
              name: fileObj.name || fileObj.fileName
            },
            name: fileObj.name || fileObj.fileName
          }
          state.gb_application[itemIndex].files.push(structuredFile)
        }
      }
    },
    setGbApplicationDocumentsFromAPI: (state, action) => {
      state.gb_application = action.payload
      return state
    },
    setGbApplicationDocFileWithData: (state, action) => {
      const { no, file } = action.payload

      if (!state.gb_application[no]) {
        state.gb_application[no] = { files: [] }
      }

      if (!state.gb_application[no].files) {
        state.gb_application[no].files = []
      }

      state.gb_application[no].files.push(file)
      return state
    },
    removeGbApplicationDocFile: (state, action) => {
      const { no, file_no } = action.payload
      state.gb_application[no].files.splice(file_no, 1)
      return state
    },
    deleteGbApplicationFile: (state, action) => {
      const { id = '' } = action.payload
      const updatedFiles = state.gb_application.filter(file => file.id !== id)
      return {
        ...state,
        gb_application: updatedFiles
      }
    },
    deleteGbApplicationImage: (state, action) => {
      const { id } = action.payload
      const nodeIndexById = state.gb_application.findIndex(node => node.id === id)
      if (nodeIndexById !== -1) {
        state.gb_application.splice(nodeIndexById, 1)
      }
    },
    deleteGbApplicationByIndex: (state, action) => {
      const { index } = action.payload
      if (index >= 0 && index < state.gb_application.length) {
        state.gb_application.splice(index, 1)
      }
    },
    addGbApplicationDocData: (state, action) => {
      return {
        ...state,
        gb_application: [
          ...(Array.isArray(state.gb_application) ? state.gb_application : []),
          action.payload
        ]
      }
    }
  }
})

export const {
  initializeGbApplicationFiles,
  setGbApplicationFile,
  setGbApplicationFiles,
  updateGbApplicationFile,
  setGbApplicationImage,
  setGbApplicationDocumentsFromAPI,
  setGbApplicationDocFileWithData,
  removeGbApplicationDocFile,
  deleteGbApplicationFile,
  deleteGbApplicationImage,
  deleteGbApplicationByIndex,
  addGbApplicationDocData
} = gbApplicationFilesSlice.actions

export default gbApplicationFilesSlice.reducer

